<div class="page">
  <div class="header">
    <h1 class="header-title">
      <mat-icon>commute</mat-icon>
      <span>Vervoer</span>
    </h1>
    @if (selectedTabKey !== 'vehicleGroups') {
      <button
        mat-icon-button
        class="export-button"
        aria-label="Importeren en exporteren"
        (click)="openImportExport()"
        [class.spinner]="processing()"
      >
        <mat-icon>import_export</mat-icon>
        <div class="button-text">Importeren/Exporteren</div>
      </button>
    }
  </div>
  <div class="content">
    <mat-tab-group [selectedIndex]="selectedIndex()" (selectedTabChange)="selectedIndex.set($event.index); updateUrl()">
      @for (tab of tabs; track tab.key) {
        <mat-tab>
          <ng-template mat-tab-label>
            <mat-icon>{{ tab.icon }}</mat-icon>
            <span>{{ tab.name }}</span>
          </ng-template>
          @switch (tab.key) {
            @case ('vehicles') {
              <app-vehicles #tab></app-vehicles>
            }
            @case ('vehicleGroups') {
              <app-vehicle-groups #tab></app-vehicle-groups>
            }
            @case ('rates') {
              <app-rates #tab></app-rates>
            }
          }
        </mat-tab>
      }
    </mat-tab-group>
    <input hidden type="file" accept=".xlsx" #uploader (change)="uploadedFile($event)" />
    <button mat-fab extended aria-label="Item toevoegen" (click)="activeTab?.editItem()">
      <mat-icon>add</mat-icon>
    </button>
  </div>
</div>
